import { getTour } from "../helpers/getTour";
import { ContactComponent } from "./ContactComponent";
import { FooterComponent } from "./FooterComponent";
import { TourOverview } from "./TourOverview";
import '../styles/pages/GuateTours.css';


export const GuateToursPage = () => {
  const tours = ['guate-antigua', 'guate-lago', 'guate-chichi', 'guate-tikal', 'guate-pacaya', 'guate-acatenango', 'guate-hobbitenango', 'guate-mistico', 'guate-city',];

  return (
    <div>
      <div className="tours-departing">
        <h1 className="standard-version">Tours saliendo desde Guatemala City</h1>
        <h2 className="phone-version">Tours saliendo desde Guatemala City</h2>
      </div>
      <div className="tours-overviews">
        {
          tours.map( (tourName, i) => {
            const tour = getTour(tourName);
            const { photos:img, title, id, time, priceImg, stars:calification, amountReviews:coments } = tour;
            return (
              <div className="tour" key={`tour-${i}`}>
                <TourOverview cardImg={img[0]} cardImgAlt={title} cardTitle={title} cardLink={`../tours/${id}`} cardPrice={priceImg} cardTime={time} cardCalification={calification} cardAmountComments={coments} />
              </div>
            );
          })
        }
      </div>
      <ContactComponent />
      <FooterComponent />
    </div>
  )
}
